package com.nonopn.skywatcher.common.app.pages.map.model.weather

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class PulseType {
    @SerialName("ic")
    IC,

    @SerialName("cg")
    CG,

    @SerialName("all")
    ALL;
}